import { Modal, Text } from "@edgelogistics/edge-ui/lib/components";
import React, { useCallback } from "react";
import { View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "../../../../redux/auth/authSelector";
import { forgotPassword } from "../../../../redux/auth/authActions";
import { textStyles } from "./styles";
import { UserSessionI } from "../../../../redux/auth/authTypes";

export interface ChangePasswordProps {
  open: boolean;
  handleClose: () => void;
  user: UserSessionI;
}

const ChangePassword: React.FC<ChangePasswordProps> = ({ open, handleClose, user }: ChangePasswordProps) => {
  const dispatch = useDispatch();
  const { forgotPasswordLoading } = useSelector(authSelector);

  const onSuccess = useCallback(() => {
    handleClose();
  }, [ handleClose ]);

  const handleChangePassword = useCallback(() => {
    const payload = { email: user?.email };

    dispatch(forgotPassword(payload, onSuccess));
  }, [ dispatch, onSuccess, user ]);

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      onCancel={handleClose}
      onConfirm={handleChangePassword}
      title="Change Password?"
      confirmText="Accept"
      fullWidth={false}
      loadingConfirm={forgotPasswordLoading}
      testID="changePassword"
    >
      <View>
        <Text
          text="If you want to change your password, we are going to send you an email to proceed with the action."
          style={textStyles.message}
          color="GRAY"
          noWrap={false}
        />
      </View>
    </Modal>
  );
};

export default ChangePassword;
